import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function AdminGuard({ children }) {
  const token = localStorage.getItem('cespedis_token');
  const location = useLocation();
  if (!token) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return children;
}
